import ViewProductDetails from './ViewProductDetails';

export default ViewProductDetails;